const state = {
  prefecture_id: null,
  city_id: null,
  position_type: null,
  employment_type: null,
  wishful_time: null,
  address: null,
  agent_selection_auction_ids: [],
  phone: null,
  first_name: null,
  last_name: null,
  first_name_kana: null,
  last_name_kana: null,
  age: null,
  email: null,
  message: null
};

const getters = {
  name: state =>
    [state.last_name, state.first_name].filter(text => !!text).join(" "),
  nameKana: state =>
    [state.last_name_kana, state.first_name_kana]
      .filter(text => !!text)
      .join(" ")
};

function divideName(name) {
  if (!name) {
    return null;
  }

  const divided = name.split(" ");

  return divided.length === 2 ? { last: divided[0], first: divided[1] } : null;
}

const actions = {
  initFormOptions({ dispatch }, form_options) {
    dispatch("setPrefectureId", form_options.prefecture_id);
    dispatch("setCityId", form_options.city_id);
    dispatch("setPositionType", form_options.position_type || "PY");
    dispatch("setEmploymentType", form_options.employment_type || 1);
    dispatch("setWishfulTime", form_options.wishful_time || 0);
    dispatch("setPhone", form_options.phone);
    dispatch("setAge", form_options.age);
    dispatch("setEmail", form_options.email);

    const dividedName = divideName(form_options.name);
    if (dividedName != null) {
      dispatch("setFirstName", dividedName.first);
      dispatch("setLastName", dividedName.last);
    }

    const dividedNameKana = divideName(form_options.name_kana);
    if (dividedNameKana != null) {
      dispatch("setFirstNameKana", dividedNameKana.first);
      dispatch("setLastNameKana", dividedNameKana.last);
    }
  },
  setPrefectureId({ commit }, value) {
    commit("SET_PREFECTURE_ID", value);
  },
  setCityId({ commit }, value) {
    commit("SET_CITY_ID", value);
  },
  setPositionType({ commit }, value) {
    const positionType = value ? value.toString() : null;
    commit("SET_POSITION_TYPE", positionType);
  },
  setEmploymentType({ commit }, value) {
    const employmentType = value ? value.toString() : null;
    commit("SET_EMPLOYMENT_TYPE", employmentType);
  },
  setWishfulTime({ commit }, value) {
    const wishfulTime =
      value != null && value != undefined ? value.toString() : null;
    commit("SET_WISHFUL_TIME", wishfulTime);
  },
  setAddress({ commit }, value) {
    commit("SET_ADDRESS", value);
  },
  setAgentSelectionAuctionIds({ commit }, value) {
    commit("SET_AGENT_SELECTION_AUCTION_IDS", value);
  },
  setPhone({ commit }, value) {
    commit("SET_PHONE", value);
  },
  setFirstName({ commit }, value) {
    commit("SET_FIRST_NAME", value);
  },
  setLastName({ commit }, value) {
    commit("SET_LAST_NAME", value);
  },
  setFirstNameKana({ commit }, value) {
    commit("SET_FIRST_NAME_KANA", value);
  },
  setLastNameKana({ commit }, value) {
    commit("SET_LAST_NAME_KANA", value);
  },
  setAge({ commit }, value) {
    commit("SET_AGE", value);
  },
  setEmail({ commit }, value) {
    commit("SET_EMAIL", value);
  },
  setMessage({ commit }, value) {
    commit("SET_MESSAGE", value);
  }
};

const mutations = {
  SET_PREFECTURE_ID(state, value) {
    state.prefecture_id = value;
  },
  SET_CITY_ID(state, value) {
    state.city_id = value;
  },
  SET_POSITION_TYPE(state, value) {
    state.position_type = value;
  },
  SET_EMPLOYMENT_TYPE(state, value) {
    state.employment_type = value;
  },
  SET_WISHFUL_TIME(state, value) {
    state.wishful_time = value;
  },
  SET_ADDRESS(state, value) {
    state.address = value;
  },
  SET_AGENT_SELECTION_AUCTION_IDS(state, value) {
    state.agent_selection_auction_ids = value;
  },
  SET_PHONE(state, value) {
    state.phone = value;
  },
  SET_FIRST_NAME(state, value) {
    state.first_name = value;
  },
  SET_LAST_NAME(state, value) {
    state.last_name = value;
  },
  SET_FIRST_NAME_KANA(state, value) {
    state.first_name_kana = value;
  },
  SET_LAST_NAME_KANA(state, value) {
    state.last_name_kana = value;
  },
  SET_AGE(state, value) {
    state.age = value;
  },
  SET_EMAIL(state, value) {
    state.email = value;
  },
  SET_MESSAGE(state, value) {
    state.message = value;
  }
};

export default {
  namespaced: true,
  state: () => state,
  getters,
  actions,
  mutations
};
